<template>
  <div :class="$style.no_results">
    <img
      :src="imageSrc"
      :class="$style.no_results__image"
      alt=""
    />
    <div :class="$style.no_results__text">
      {{ locales('lc_search_no_results_full') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'LearningCenterSearchNoResults',
  data() {
    return {
      locales: __,
    };
  },
  computed: {
    imageSrc() {
      return `${GT.cdn}/imgs/learnCenter/no-search-results-stub.png`;
    },
  },
};
</script>

<style module src="./search.less" lang="less"></style>


